import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { VideoDetail } from 'app/types';
import videos from 'app/config/videos.json';

@Component({
  selector: 'fintech-home',
  standalone: true,
  imports: [
    RouterModule,
  ],
  templateUrl: './home.component.html',
})
export class HomeComponent {
    title = "Kizano's FinTech";
    categories: string[] = videos.videos.map(video => video.category)
        .filter((value, index, self) => self.indexOf(value) === index);

    /**
     * Get the list of videos for a given category.
     */
    getVideos(category: string): VideoDetail[] {
        return videos.videos.filter(video => video.category === category);
    }
}
